<template>
  <div>
    <!-- Header com botões -->
    <div class="header-recibo nao-imprimir">
      <h2 class="titulo-pagina">Recibo</h2>
      <div class="botoes">
        <b-button variant="secondary" class="btn-voltar" @click="voltar">
          <i class="bi bi-arrow-left"></i> Voltar
        </b-button>
        <b-button
          :variant="isDownloading ? 'success' : 'danger'"
          class="btn-pdf"
          :disabled="isDownloading"
          @click="gerarPDF"
        >
          <i class="bi bi-file-earmark-pdf"></i>
          {{ isDownloading ? 'Baixando' : 'Baixar' }}
        </b-button>
      </div>
    </div>

    <!-- Área do recibo que será impressa/convertida em PDF -->
    <div ref="reciboContent" class="recibo-container print-area">
      <div class="recibo">

        <!-- Cabeçalho da escola -->
        <div class="recibo-header">
          <img v-if="$globalState.logoPath" :src="$globalState.logoPath" alt="Logomarca" class="header-logo"/>
          <div class="escola-info">
            <h4>{{ escola.nome }}</h4>
            <p></p>
            <p>{{ escola.slogan }}</p>
            <p>
              {{ escola.endereco }}, {{ escola.numero }}
              <span v-if="escola.complemento && escola.complemento !== 'null'">
                , {{ escola.complemento }}
              </span>
              - {{ escola.bairro }}
            </p>
            <p>{{ escola.municipio }} - {{ escola.estado }}, CEP: {{ escola.cep }}</p>
            <p>
              <i class="bi bi-telephone"></i> {{ escola.telefone }}
              <i class="bi bi-whatsapp text-success"></i> {{ escola.whatsapp }}
            </p>
          </div>
        </div>

        <!-- Título do recibo -->
        <h3 class="recibo-title">RECIBO - MATRÍCULA</h3>

        <!-- Bloco de Cliente e Dados da Matrícula -->
        <table class="info-table">
          <tbody>
            <tr>
              <td><strong>Cliente:</strong></td>
              <td>{{ recibo.responsavel_nome || recibo.aluno_nome }}</td>
              <td><strong>C.P.F.:</strong></td>
              <td>{{ formatarCPF(recibo.cpf_responsavel) }}</td>
            </tr>
            <tr>
              <td><strong>Matrícula:</strong></td>
              <td>
                Mat: {{ recibo.id }}
                <template v-if="recibo && (recibo.contrato_selecionado || $route.query?.contrato || recibo.contrato_atual || recibo.numero_contrato)">
                  — Contrato:
                  {{ recibo.contrato_selecionado || $route.query?.contrato || recibo.contrato_atual || recibo.numero_contrato }}
                </template>
              </td>
              <td><strong>Plano do Contrato:</strong></td>
              <td>{{ recibo.plano_atual }}</td>
            </tr>
          </tbody>
        </table>

        <!-- Bloco Aluno / Instrutor -->
        <table class="info-table mt-2">
          <tbody>
            <tr>
              <td><strong>Aluno / Nível:</strong></td>
              <td>
                {{ recibo.aluno_nome }}

                <span v-if="nivelRecibo">
                  / {{ nivelRecibo }}
                </span>
              </td>
            </tr>

            <tr>
              <td><strong>Instrutor – Turma:</strong></td>
              <td>
                <template v-if="recibo.turmas_historicas_disponiveis === false">
                  <span class="text-muted">
                    {{ recibo.turmas_observacao || "Turmas históricas não disponíveis para este contrato." }}
                  </span>
                </template>

                <template v-else-if="recibo.turmas && recibo.turmas.length">
                  <ul class="lista-turmas">
                    <li
                      v-for="t in recibo.turmas"
                      :key="t.id || t.turma_completa || `${t.turma_numero}-${t.dia_semana}-${t.horario}`"
                    >
                      <template v-if="t.turma_completa">
                        {{ t.turma_completa }}
                      </template>

                      <template v-else>
                        {{ t.instrutor_nome }} | Turma {{ t.turma_numero }}
                        | {{ t.dia_semana }} | {{ t.horario }}
                      </template>
                    </li>
                  </ul>
                </template>

                <template v-else>
                  <span class="text-muted">Nenhuma turma informada.</span>
                </template>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Texto introdutório -->
        <p class="recibo-texto">
        Recebemos do cliente acima citado, a importância de
        <strong>{{ utils.formatarValor(recibo.total_recebido) }}</strong>
        <em> ({{ extenso(recibo.total_recebido) }})</em>,
        discriminada conforme matrícula contratada abaixo:
        </p>

        <!-- Tabela de pagamentos -->
        <table class="aula-table">
          <thead>
            <tr>
              <th>Tipo Parcela</th>
              <th>Valor</th>
              <th>Vencimento</th>
              <th>Pagamento</th>
              <th>Forma de Pagamento</th>
              <th>Obs.</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="p in recibo.pagamentos" :key="p.id">
              <td>{{ p.tipo }}</td>
              <td>{{ utils.formatarValor(p.valor) }}</td>
              <td>{{ utils.formatarData(p.data_vencimento) }}</td>
              <td>
                {{ p.data_pagamento
                  ? utils.formatarData(p.data_pagamento)
                  : "Pendente" }}
              </td>
              <td>{{ p.forma_pagamento }}</td>
              <td>{{ p.observacoes || "--" }}</td>
            </tr>
          </tbody>
        </table>

        <!-- Observações fixas -->
        <div class="observacoes">
          <h4>OBSERVAÇÕES IMPORTANTES:</h4>
          <ol>
            <li>
              O PAGAMENTO EFETUADO EM CHEQUE(S) E/OU BOLETO(S) SÓ VALIDARÁ O
              PRESENTE RECIBO APÓS A(S) DEVIDA(S) COMPENSAÇÃO(ÕES).
            </li>
            <li>
              ESTE RECIBO SUBSTITUI OUTROS QUE PORVENTURA TENHAM SIDO
              GERADOS ANTERIORMENTE.
            </li>
          </ol>
        </div>

        <!-- Rodapé de data e assinaturas -->
        <div class="assinatura-container">
          <p class="texto-final">
            Por ser verdade, firmamos o presente recibo em 02 (duas) vias de
            igual teor e conteúdo.
          </p>
          <p class="data-local">
            {{ escola.municipio }} - {{ escola.estado }}, {{ formatarDataAtual() }}
          </p>
          <div class="assinaturas">
            <div class="assinatura">
              <hr />
              <p>{{ escola.nome }}</p>
              <p>CNPJ: {{ formatarCNPJ(escola.cnpj) }}</p>
            </div>
            <div class="assinatura">
              <hr />
              <p>{{ recibo.responsavel_nome || recibo.aluno_nome }}</p>
              <p>CPF: {{ formatarCPF(recibo.cpf_responsavel) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/services/axios";
import { BButton } from "bootstrap-vue-next";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import globalUtils from "@/utils/globalUtils.js";

export default {
  name: "ImprimirReciboMatricula",
  components: { BButton },
  data() {
    return {
      isDownloading: false,
      recibo: { pagamentos: [] },
      escola: {},
    };
  },
  watch: {
    // Se mudar só o ?contrato, recarrega o recibo
    '$route.query.contrato'() {
      this.carregarRecibo();
    }
  },
  computed: {
    utils() {
      return globalUtils;
    },

    instrutorTurmas() {
      return this.recibo.instrutor_turma_info || "—";
    },

    selectedContrato() {
      return (
        this.recibo?.contrato_selecionado ||
        this.$route?.query?.contrato ||
        this.recibo?.contrato_atual ||
        this.recibo?.numero_contrato ||
        null
      );
    },

    nivelRecibo() {
      const turmas = this.recibo?.turmas || [];
      const primeiraTurmaComNivel = turmas.find((t) => t.nivel);

      return primeiraTurmaComNivel?.nivel || this.recibo?.nivel || "";
    },
  },

  methods: {
    async carregarRecibo() {
      const { id } = this.$route.params;
      // pegue o contrato da query; transforme em string para evitar undefined/null
      const contrato = (this.$route.query && this.$route.query.contrato)
        ? String(this.$route.query.contrato)
        : null;

      try {
        const base = `/operacional/recibo-matricula/matriculas/${id}/recibo`;
        const url  = contrato ? `${base}?contrato=${encodeURIComponent(contrato)}` : base;

        const { data } = await axios.get(url);
        this.recibo = data;

        // 1) Busca dados da empresa
        const empresa = (await axios.get("configuracoes/empresa")).data;

        // 2) Resolve UF/município
        let estadoSigla = "UF";
        let municipioNome = "Cidade não informada";
        if (empresa.estado_cod) {
          const estados = (await axios.get(`/localidades/estados`)).data;
          const estadoObj = estados.find(e => e.id === empresa.estado_cod);
          if (estadoObj) estadoSigla = estadoObj.sigla;

          const municipios = (await axios.get(`/localidades/municipios/${empresa.estado_cod}`)).data;
          const municipioObj = municipios.find(m => Number(m.id) === Number(empresa.municipio_cod));
          if (municipioObj) municipioNome = municipioObj.nome;
        }
        this.escola = {
          razao_social: empresa.razao_social,
          nome: empresa.razao_social,
          cnpj: empresa.cnpj,
          endereco: empresa.endereco,
          numero: empresa.numero,
          complemento: empresa.complemento,
          bairro: empresa.bairro,
          slogan: empresa.slogan,
          municipio: municipioNome,
          estado: estadoSigla,
          cep: empresa.cep,
          telefone: empresa.telefone1,
          whatsapp: empresa.whatsapp_url,
        };
      } catch (err) {
        console.error("❌ Erro ao carregar recibo:", err);
      }
    },
    formatarDataAtual() {
      return new Date().toLocaleDateString("pt-BR");
    },
    formatarCNPJ(cnpj) {
      return globalUtils.formatarCNPJ(cnpj);
    },
    formatarCPF(cpf) {
        if (!cpf) return "";
        // remove tudo que não for dígito
        const s = cpf.replace(/\D/g, "");
        // formata 11 dígitos: 12345678900 → 123.456.789-00
        return s.length === 11
        ? s.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
        : cpf;
    },

    extenso(val) {
        const num = Number(val) || 0;
        return this.utils.valorPorExtenso(num);
    },

    async gerarPDF() {
      this.isDownloading = true;
      const el = this.$refs.reciboContent;
      try {
        const canvas = await html2canvas(el, { scale: 2, useCORS: true });
        const img = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const width = 210;
        const height = (canvas.height * width) / canvas.width;
        pdf.addImage(img, "PNG", 0, 10, width, height);
        pdf.save(`recibo-matricula-${this.recibo.id}.pdf`);
      } catch (e) {
        console.error(e);
      } finally {
        this.isDownloading = false;
      }
    },
    voltar() {
    // redireciona para a página de detalhes da mesma matrícula
    this.$router.push({
        name: "DetalharMatriculas",
        params: { id: this.recibo.id }
    });
    },
  },
  mounted() {
    this.carregarRecibo();
  },
};
</script>

<style scoped>
  .recibo-container {
    max-width: 800px;
    margin: auto;
    background: white;
    padding: 20px 40px; /* 20px em cima/baixo e 40px nas laterais */
    border: none
  }
  .recibo-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .logo {
    width: 80px;
  }
  .escola-info {
    text-align: center;
    margin: 0; /* Remove as margens verticais */
    line-height: 0; /* ✅ Reduz o espaçamento entre as linhas */
    font-size: 11px; /* ✅ Ajusta o tamanho da fonte */
  } 
  .recibo-title {
    text-align: center;
    margin-top: 30px;
    margin-bottom: 30px;
    font-size: 18px;
    font-weight: bold;
  }
  .info-table, .aula-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
  }
  .info-table td,
  .aula-table th,
  .aula-table td {
    border: 1px solid #ddd;
    padding: 8px;
    padding-top: 4px !important;
    padding-bottom: 4px !important;
    line-height: 1.2 !important;
  }
  .aula-table th {
    background-color: #f2f2f2;
  }
  .observacoes {
    background: #f8f9fa;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #ddd;
    font-size: 11px; /* 🔹 Reduzindo o tamanho da fonte das observações */
    font-weight: normal;
    margin-top: 30px; /* 🔹 Criando espaço entre a tabela e as observações */
  }  
  .observacoes h4 {
    font-size: 12px; /* 🔹 Reduzindo o tamanho do título */
    font-weight: bold;
    margin-bottom: 10px;
  }

  .observacoes ol {
    margin: 0;
    padding-left: 20px;
  }

  .observacoes ul {
    list-style-type: none;
    padding: 0;
  }
  .observacoes li {
    margin-bottom: 4px;
    line-height: 1.5;
    text-transform: uppercase;
    margin-left: 20px;
  }
  .assinatura {
    text-align: center;
    margin-top: 20px;
  }

  .botoes {
    display: flex;
    align-items: center; /* 🔹 Garante que ambos os botões fiquem alinhados verticalmente */
    justify-content: flex-end; /* 🔹 Alinha os botões à direita */
    gap: 10px; /* 🔹 Mantém um espaçamento entre os botões */
  }


  .btn-voltar {
  width: 70px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px; /* 🔹 Reduz o tamanho do texto */
  padding: 4px 8px; /* 🔹 Ajusta o preenchimento para reduzir o tamanho do botão */
  height: 30px; /* 🔹 Define uma altura menor */
}

.btn-pdf {
  width: 70px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px; /* 🔹 Reduz o tamanho do texto */
  padding: 4px 8px; /* 🔹 Ajusta o preenchimento para reduzir o tamanho do botão */
  height: 30px; /* 🔹 Define uma altura menor */
}


  .botoes .btn-imprimir {
  width: 33px;  /* ✅ Mesmo tamanho da altura do botão Voltar */
  height: 33px; /* ✅ Altura igual à largura, tornando-o quadrado */
  padding: 6px;
  border-radius: 6px; /* 🔹 Ajuste se quiser cantos levemente arredondados */
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto; /* ✅ Move o botão para a direita */

}

.botoes .btn-imprimir i {
  font-size: 18px; /* Ajuste do ícone dentro do botão */
}

  .header-logo {
  height: 60px;
}

.bi-telephone, .bi-whatsapp {
  margin-right: 2px;
  margin-left: 10px;
}

.recibo-texto {
  font-size: 12px;
  margin-top: 40px;
  margin-bottom: 30px;
}

.assinatura-container {
  text-align: center;
  margin-top: 20px;
}

.texto-final {
  font-size: 12px;
  font-weight: normal;
  margin-bottom: 30px;
  text-align: left;
}

.data-local {
  font-size: 12px;
  font-weight: normal;
  margin-bottom: 15px;
}

.assinaturas {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
}

.assinatura {
  text-align: center;
  width: 45%;
  padding-top: 5px; /* Reduz espaço entre linha e nome */
  font-size: 12px; /* Opcional: reduzir fonte */
  line-height: 0.4; /* 🔹 Reduz espaço entre as linhas */
}

.assinatura hr {
  border: none;
  border-top: 1px solid black;
  margin: 10px auto;
  width: 80%;
}

.header-recibo {
  display: flex;
  justify-content: space-between; /* Alinha o título à esquerda e os botões à direita */
  align-items: center;
  padding: 10px 20px;
  border-bottom: 1px solid #ddd; /* Linha separadora */
  margin-bottom: 20px; /* Espaço entre o header e o recibo */
}

.titulo-pagina {
  font-size: 20px;
  font-weight: bold;
  color: #444;
}

.botoes {
  display: flex;
  flex-direction: column; /* 🔹 Botões em coluna (um abaixo do outro) */
  gap: 8px; /* 🔹 Espaço entre os botões */
}
.lista-turmas {
  list-style: disc inside;
  margin: 0;
  padding: 0;
}
.lista-turmas li {
  margin-bottom: 4px;
}


</style>
